import { Injectable } from '@odinjs/odin';
import { FileService } from '@philips-internal/oswald-ui-components';

import { VersionRoutesAPI } from '../constants';

@Injectable({})
export class VersionFileService {

  static download(fileId: number | string, fileName: string): Promise<Blob> {
    return FileService.download(VersionRoutesAPI.VERSION_FILE_DOWNLOAD,
      fileName,
      { fileId });
  }

}
